'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _velocityAnimate = require('velocity-animate');

var _velocityAnimate2 = _interopRequireDefault(_velocityAnimate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cardHeights = function cardHeights() {
  var cardEnter = function cardEnter(event) {
    var element = event.target;
    var target = element.dataset.cardHover;
    var targetElement = event.target.querySelector(target);
    var targetHeight = targetElement.dataset.hoverHeight + 'px';

    if (!(targetElement.classList.contains('is-animating-in') || targetElement.classList.contains('is-default-size'))) {
      Velocity(targetElement, { maxHeight: targetHeight }, {
        duration: 200,
        easing: [.12, .98, .33, .99],
        begin: function begin(elements) {
          elements.forEach(function (el, index) {
            el.classList.add('is-animating-in');
          });
        },
        complete: function complete(elements) {
          elements.forEach(function (el, index) {
            el.classList.remove('is-animating-in');
            el.classList.add('is-animated-in');
          });
        }
      });
    }
  };

  var cardLeave = function cardLeave(event) {
    var element = event.target;
    var target = element.dataset.cardHover;
    var targetElement = element.querySelector(target);

    if (!(targetElement.classList.contains('is-animating-out') || targetElement.classList.contains('is-default-size'))) {
      Velocity(targetElement, { maxHeight: 0 }, {
        duration: 200,
        easing: [.12, .98, .33, .99],
        begin: function begin(elements) {
          elements.forEach(function (el, index) {
            el.classList.remove('is-animated-in');
            el.classList.add('is-animating-out');

            var dropdownItems = el.querySelectorAll('[data-trigger="dropdown"][data-target]');
            dropdownItems.forEach(function (item, index) {
              var targetDropdown = item.dataset.target;
              Limelight.elements[targetDropdown].hide();
            });
          });
        },
        complete: function complete(elements) {
          elements.forEach(function (el, index) {
            el.classList.remove('is-animating-out');
          });
        }
      });
    }
  };

  var updateCardItems = function updateCardItems() {
    var cardItemHeights = document.querySelectorAll('[data-card-height][data-card-height-target]');
    var cardItems = document.querySelectorAll('[data-card-hover]');

    // Update the correct height to each hover card item
    cardItemHeights.forEach(function (element, index) {
      var item = element;
      var container = item.dataset.cardHeight;
      var target = item.dataset.cardHeightTarget;
      var containerHeight = item.querySelector(container).offsetHeight;
      var targetElement = item.querySelector(target);

      targetElement.style.height = containerHeight + 'px';
      item.classList.remove('is-default-height');
    });

    // Update the hover states for each card item
    cardItems.forEach(function (element, index) {
      var item = element;
      var target = item.dataset.cardHover;
      var targetElement = item.querySelector(target);

      targetElement.style.maxHeight = 'none';
      var targetElementHeight = targetElement.offsetHeight;
      targetElement.style.maxHeight = 0;
      targetElement.dataset.hoverHeight = targetElementHeight;

      item.addEventListener('mouseenter', cardEnter);
      item.addEventListener('mouseleave', cardLeave);
    });
  };

  var removeAndUpdateCardItems = function removeAndUpdateCardItems() {
    var cardItems = document.querySelectorAll('[data-card-hover]');

    cardItems.forEach(function (element, index) {
      var item = element;
      item.removeEventListener('mouseenter', cardEnter);
      item.removeEventListener('mouseleave', cardLeave);
    });

    updateCardItems();
  };

  window.addEventListener('resize', removeAndUpdateCardItems);
  window.addEventListener('orientationchange', removeAndUpdateCardItems);
  document.addEventListener('slick:resize', removeAndUpdateCardItems);
  document.addEventListener('cards:resize', removeAndUpdateCardItems);
  document.addEventListener('bcs:product-inserted', removeAndUpdateCardItems);
  updateCardItems();
};

exports.default = cardHeights;